export default __webpack_public_path__ + "static/media/Password-icon.4a2a4058.svg";